import starIcon from '@iconify/icons-ant-design/star-filled';
import starIconOutline from '@iconify/icons-ant-design/star-outline';
import { InlineIcon } from '@iconify/react/dist/iconify';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const RatingContainer = styled.div``;

const MAX_RATING = 5;

const StyledInlineIcon = styled(InlineIcon)`
  display: inline-block;
`;

export function Rating({ value }) {
  // The number of stars are calculated to be at the most 5. This is necessary because some listings
  // comes with scores higher than 5. This will not show the real score until there are normalized values
  // that are calcualted in the scrapping process (and/or the backend).
  // This should be considered a temporal solution that helps prevent the frontend from failing, rather than a definite solution
  //
  // See https://deckardtech.atlassian.net/browse/TS-2258 for further details.
  const solidStars = useMemo(() => {
    const normalizedValue = value > MAX_RATING ? MAX_RATING : value;
    return new Array(normalizedValue).fill(
      <StyledInlineIcon icon={starIcon} />
    );
  }, [value]);

  const emptyStars = useMemo(() => {
    const size = MAX_RATING - value < 0 ? 0 : MAX_RATING - value;
    return new Array(size).fill(<StyledInlineIcon icon={starIconOutline} />);
  }, [value]);

  return (
    <RatingContainer>
      {solidStars}
      {emptyStars}
    </RatingContainer>
  );
}
